/**
 * API configuration constants
 */

// Base URL for API endpoints
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost:18520';

// API Endpoints
export const API_ENDPOINTS = {
  // Navigation endpoints
  NAVIGATION: {
    BASE: '/api/public/nav',
    BY_LANGUAGE: (language: string) => `/api/public/nav/${language}`,
    SET_LANGUAGE: (language: string) => `/api/public/nav/language/${language}`,
    LANGUAGES: '/api/public/nav/languages'
  }
};

// Log the API base URL for debugging
console.log("API_BASE_URL", API_BASE_URL);

console.log("process.env", process.env);

export const getData = (userId: number): string => {
    return API_BASE_URL + '/data/' + userId
}


export const ACCESS_TOKEN = 'accessToken';

// export const OAUTH2_REDIRECT_URI = localurl+'/oauth2/redirect';
export const OAUTH2_REDIRECT_URI = API_BASE_URL+'/oauth2/redirect';

export const GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = API_BASE_URL + '/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;